import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-explore-one',
  templateUrl: './breadcrumb-explore-one.component.html',
  styleUrls: ['./breadcrumb-explore-one.component.scss']
})
export class BreadcrumbExploreOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
